$(function(){
  if($(window).width() < 990){
    let logo = $('.header__logo').detach()
    $('.u_header_mobile_left').append(logo)
    $(".header__mobile__left,.header__mobile__right").wrapAll('<div class="u_header_mobile_right" />');
    $(document).on('click','.u_input_search',function(){
      $('.u_mb_search_btn').hide()
    })
    $(document).on('click','.drawer__close',function(){
      $('.u_input_search').val('')
      $('.u_predictive_body').empty().hide()
      $('.u_mb_search_btn').show()
    })

    $(document).on('keyup','.u_input_search',function(){
      $('.u_mb_search_btn').hide()
      let searchTerm = $(this).val();
      console.log('keyup',searchTerm.length)
      if(searchTerm.length != 0){
        console.log('if condition',searchTerm.length)
        fetch(`/search/suggest?q=${searchTerm}&resources[type]=query,product,collection,page,article&section_id=c-predictive-search`)
        .then((response)=>{
          if(response.status == '200'){
            $('.u_animated_cont').show()
            $('body').addClass('u_body_overflow')
            return response.text()        
          }

        })
        .then((resolve)=>{
          setTimeout(function(){
            $('.u_animated_cont').hide()        
            $('.u_predictive_body').show().html(resolve)        
          },1000)
        }).
        catch((err)=>{
          console.log('error',err) 
        })
      }
      else{
        console.log('if condition',searchTerm.length)
        $('.u_predictive_body').empty().hide()
        $('body').removeClass('u_body_overflow')
        $('.u_mb_search_btn').show()
      }
    })
    $(document).on('click','.header__mobile__hamburger,.drawer__close,.ms_hr_cart_icon_tab',function(){
      $('.theme__header').toggleClass('u_hactive')
    })

    // $(window).scroll(function(){
    //   var scroll = $(window).scrollTop();    
    //   if (scroll <= 500) {
    //     $(".theme__header").addClass("js__header__stuck");
    //   }
    // }
    
  }
})
